import { useEffect, useRef, useState } from 'react';

import { BannerData, bannerDataList } from '../lib/bannerData';
import { BANNER_CONFIG } from '../lib/constants';

const useMainBannerViewModel = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [currentBannerIndex, setCurrentBannerIndex] = useState<number>(0);
  const [currentBanner, setCurrentBanner] = useState<BannerData>(bannerDataList[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % bannerDataList.length;
        setCurrentBanner(bannerDataList[nextIndex]);
        return nextIndex;
      });
    }, BANNER_CONFIG.BANNER_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return {
    ref,
    currentBanner,
    currentBannerIndex,
  };
};

export default useMainBannerViewModel;
